import { TAB_ID, SESSION_ID } from "infrastructure/tabIdentity";

const LEADER_KEY = "neoconecta-tab-leader";
const HEARTBEAT_KEY = "neoconecta-tab-heartbeat";
const HEARTBEAT_INTERVAL = 2000; // 2s
const HEARTBEAT_TIMEOUT = 5000;  // 5s

let role = null; // "unknown" | "leader" | "follower"
let heartbeatTimer = null;

export function initTabLeader({ onUnknown, onFollower, onBecomingLeader, onLosingLeader }) {
  
  function setRole(nextRole, meta = null) {
    if (role === nextRole) return;

    role = nextRole;

    switch (role) {
      case "unknown":
        onUnknown?.();
        break;
      case "leader":
        onBecomingLeader?.(meta);
        break;
      case "follower":
        onFollower?.();
        break;
    }
  }

  function writeLeader() {
    localStorage.setItem(
      LEADER_KEY,
      JSON.stringify({
        tabId: TAB_ID,
        sessionId: SESSION_ID
      })
    );

    localStorage.setItem(HEARTBEAT_KEY, Date.now());
  }

  function getCurrentLeader() {
    try {
      return JSON.parse(localStorage.getItem(LEADER_KEY));
    } catch {
      return null;
    }
  }
  
  function tryBecomeLeader() {
    const leader = getCurrentLeader();
    const lastBeat = Number(localStorage.getItem(HEARTBEAT_KEY) || 0);
    const now = Date.now();

    const leaderAlive =
      leader &&
      leader.tabId !== TAB_ID &&
      now - lastBeat <= HEARTBEAT_TIMEOUT;

    if (!leaderAlive) {
      const previousLeader = becomeLeader();
      setRole("leader", { previousLeader });
      return;
    }

    if (role !== null) {
      setRole("follower");
    }
  }

  function becomeLeader() {
    if (heartbeatTimer) return;

    const previousLeader = getCurrentLeader();

    writeLeader();

    heartbeatTimer = setInterval(writeLeader, HEARTBEAT_INTERVAL);

    return previousLeader;
  }

  function loseLeader() {
    if (role !== "leader") return;

    clearInterval(heartbeatTimer);
    heartbeatTimer = null;

    onLosingLeader?.();
    setRole("follower");
  }

  window.addEventListener("storage", () => {
    const leader = getCurrentLeader();

    if (
      role === "leader" &&
      leader &&
      leader.tabId !== TAB_ID
    ) {
      loseLeader();
    }
  });

  // Intentar liderazgo al iniciar
  setRole("unknown");
  tryBecomeLeader();

  // Reintentar periódicamente
  setInterval(tryBecomeLeader, HEARTBEAT_INTERVAL);
}
